import { defineMessages } from 'react-intl';

export default defineMessages({
    eachLocationRequiresUniqueAddress: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHOContentsOffPremisesCov.WMICHOContentsOffPremisesCovDetailView.WMICHOContentsOffPremisesCovDetailView.Each location requires a unique address',
        defaultMessage: 'Each location requires a unique address.',
    },
});
